import React from "react";

interface SearchInputProps {
  value: string;
  onChange: (event: any) => void;
  type?: string;
  placeholder: string;
  onKeyDown: (e: any) => void;
}

export default function SearchInput(props: SearchInputProps) {
  return (
    <input
      className="form-control"
      onChange={props.onChange}
      value={props.value}
      type={props.type}
      placeholder={props.placeholder}
      onKeyDown={props.onKeyDown}
    />
  );
}
